import { render, staticRenderFns } from "./Drop.vue?vue&type=template&id=54d006c8&scoped=true&"
import script from "./Drop.vue?vue&type=script&lang=js&"
export * from "./Drop.vue?vue&type=script&lang=js&"
import style0 from "./Drop.vue?vue&type=style&index=0&id=54d006c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d006c8",
  null
  
)

export default component.exports